import * as React from 'react'

const LabelHeader = ({ label }) => {
  return (
    <div className="tw-text-sm tw-font-medium tw-text-content-base">
      {label}
    </div>
  )
}

export default LabelHeader
